module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADxSURBVGiB7dlNDoIwEAXgV/FgLDkRcQfdGU7EshfDukGDDAZMOwzE9+1oZDLPdvwJABGRJTdfqG6xxIAGDmVCXd93rk24f7OLWElvHgCaqo5tYo1NZID05l92CSED5KUeQs5AHeP0uu+ceM03Y7NNelsLIgIK+P7uwnQ56w6Mg+tz1nxzKPGQxzv7EVINsbC7KjOgHOLDVavwGKJNrTOfyTntTyF1DGBtdQbWzqC10+8AA1hbnYFffgtp4PfA0TGANQawxgDWGMAaA1hjAGunD8D/xNZkgIiwfxsbLfQmj1ABjwE5H3Tk4lEc+M0loj/1BAUeOUj26TNyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/path_config_on.png
// module id = 5d9H
// module chunks = 3